import {Alert, Box} from '@mui/material';
import * as React from 'react';
import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import QuickSightEmbed from '../../admin/components/quicksight-embed';
import {exchangeGuestReportToken} from '../services/guest-report-service';

function GuestReportEmbedView() {
  const {token: rawToken} = useParams<{token: string}>();
  const token = rawToken ? decodeURIComponent(rawToken) : undefined;
  const [embedUrl, setEmbedUrl] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!token) {
      setErrorMessage('This report link is invalid.');
      setIsLoading(false);
      return;
    }

    let cancelled = false;

    exchangeGuestReportToken(token)
      .then((response) => {
        if (!cancelled) {
          setEmbedUrl(response.embedUrl);
          setErrorMessage(null);
        }
      })
      .catch((error) => {
        if (cancelled) {
          return;
        }

        const responseData = error?.response?.data;
        const apiMessage = typeof responseData === 'string'
          ? responseData
          : responseData?.message;
        if (error?.response?.status === 410) {
          setErrorMessage('This report link has expired.');
        } else if (apiMessage) {
          setErrorMessage(apiMessage);
        } else {
          setErrorMessage('Unable to load this report link.');
        }
      })
      .finally(() => {
        if (!cancelled) {
          setIsLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [token]);

  if (errorMessage) {
    return (
      <Box sx={{maxWidth: 640, margin: '48px auto', padding: 2}}>
        <Alert severity="error">{errorMessage}</Alert>
      </Box>
    );
  }

  return (
    <QuickSightEmbed
      dashboardUrl={embedUrl}
      isLoading={isLoading}
      height="900px"
    />
  );
}

export default GuestReportEmbedView;
